import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const RewardingEventsRoutes: Routes = [
  {
    path: "rewarding-events",
    loadComponent: () =>
      import("./rewarding-events/rewarding-events.component").then(
        (m) => m.RewardingEventsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./rewarding-events-list/rewarding-events-list.component").then(
            (m) => m.RewardingEventsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./rewarding-events-form/rewarding-events-form.component").then(
            (m) => m.RewardingEventsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./rewarding-events-form/rewarding-events-form.component").then(
            (m) => m.RewardingEventsFormComponent,
          ),
      },
    ],
  },
];
